import { Course_Videos_Statuses_Enum as CourseVideoStatus } from '@lyon/graphql/types';
import { IFormQuestionsResult, IFormsResult } from './forms';

export enum ModuleItemType {
  ARTICLE = 'article',
  VIDEO = 'video',
  ASSESSMENT = 'assessment',
  ATTACHMENT = 'attachment',
  LIVE_SESSION = 'live-session',
  FORM = 'form',
}

export const MODULE_ITEM_TYPE = {
  0: ModuleItemType.ARTICLE,
  1: ModuleItemType.VIDEO,
  2: ModuleItemType.ASSESSMENT,
  3: ModuleItemType.ATTACHMENT,
  4: ModuleItemType.LIVE_SESSION,
  5: ModuleItemType.FORM,
};

export enum StreamingService {
  ZOOM_MEETING = 0,
  ZOOM_WEBINAR = 1,
  GOOGLE_MEET = 2,
  JITSI = 3,
  CUSTOM_LINK = 4,
}
export interface IModuleItemResult {
  readonly id: string;
  readonly title: string;
  readonly itemType: ModuleItemType;
  readonly isFree: boolean;
  readonly isLocked: boolean;
  readonly order: number;
  readonly courseModuleId: string;
  readonly updatedAt: string;
  readonly createdAt: string;
  readonly enableCommentSection?: boolean;

  // Generated
  readonly duration?: number; // in seconds
}

export interface ICourseArticleResult extends IModuleItemResult {
  id: string;
  body: string;
  moduleItemId: string;
}

export interface ICourseLiveSessionResult extends IModuleItemResult {
  id: string;
  description?: string;
  customLink?: string;
  sessionDate?: Date;
  timeStart?: Date;
  timeEnd?: Date;
  streamingService?: StreamingService;
  moduleItemId: string;
  attendanceEnabled: boolean;
}

export interface IJoinSessionResult extends IModuleItemResult {
  id: string;
  description?: string;
  customLink?: string;
  sessionDate?: string;
  timeStart?: string;
  timeEnd?: string;
  streamingService?: StreamingService;
  moduleItemId: string;
  attendanceEnabled: boolean;
  courseId: string;
}

export interface ICourseFormResult extends IModuleItemResult {
  id: string;
  formId: string;
  moduleItemId: string;
  details?: Partial<IFormsResult>;
}

export interface ICourseFormManagementResult {
  id: string;
  formId: string;
  moduleItemId: string;
  courseModuleId: string;
  formDetails: Partial<IFormsResult>;
  formQuestions: Partial<IFormQuestionsResult>[];
}

export interface ICourseFormsResult {
  id: string;
  formId: string;
  moduleItemId: string;
  formTitle?: string;
  formDescription?: string;
  moduleItemTitle?: string;
  courseModuleTitle?: string;
}

export interface ICourseVideoResult extends IModuleItemResult {
  id: string;
  videoUrl: string;
  description: string;
  moduleItemId: string;
  status: CourseVideoStatus;
}

export interface ICoursePdfResult extends IModuleItemResult {
  id: string;
  url: string;
  moduleItemId: string;
}
